import axios from 'axios';

const api = axios.create({
  baseURL: "http://app.svk.com/api",
  headers: {
    Accept: 'application/json',
  },
});

export default api;
